<template>
  <div>
    <chat-message
      v-if="sprintMessage !== null"
      :channelId="channelId"
      :selected="false"
      :key="
        `${sprintMessage.channel}-${sprintMessage.id}-${sprintMessage.uuid}}`
      "
      :message="sprintMessage.message"
      :file="sprintMessage.file || null"
      :date="sprintMessage.timetoken"
      :current-user="currentUser"
      :reactions="[]"
      :chat-users="chatUsers"
      :get-file-url="getFileUrl"
      :media-library-files="
        (sprintMessage.message || {}).mediaLibraryFiles || null
      "
      :static-media-id="(sprintMessage.message || {}).staticMediaId || null"
      :get-message-by-timetoken="getMessageByTimetoken"
      :get-resource-by-url="getResourceByUrl"
      :parse-output-message-text="parseOutputMessageText"
      :get-resource-by-id="getResourceById"
      :send-existing-resource="sendExistingResource"
      :is-role-allowed="isRoleAllowed"
      :direct-chat="directChat"
      :is-sprint-message-outside="true"
      @setSelectedMessage="() => {}"
      @reactionClicked="false"
      @removeMessage="() => {}"
      @ackMessage="() => {}"
      @copyMessage="() => {}"
      @askAi="() => {}"
      @imageLoaded="imageLoaded"
      @showBiggerImage="showBiggerImage"
      @downloadFile="$emit('downloadFile', $event)"
      @downloadResourceByUrl="downloadResourceByUrlHandler"
    />
    <v-container
      :id="`message-${messageId}`"
      :class="
        `chat-message-container ${
          replyMessage ? 'chat-message-container--reply' : ''
        }${selected ? ' chat-message--selected' : ''}${
          isSprintMessageOutside
            ? ' chat-message-container--copied-sprint-message'
            : ''
        }`
      "
      :key="messageId"
    >
      <v-row :justify="isMessageOwner ? 'end' : 'start'">
        <profile-preview-image
          v-if="!isMessageOwner"
          :uuid="message.user"
          :avatarClasses="['avatar', 'rounded', `mr-4`]"
          :avatarSize="avatarSize"
        />
        <div
          class="chat-message--hover-display chat-message-actions-buttons"
          v-if="!isSprintMessageOutside"
        >
          <v-btn
            class="chat-message__reply-button"
            @click="
              $emit('setSelectedMessage', {
                ...message,
                text: '',
                method: 'REPLY',
              })
            "
            type="reverse"
            icon
            small
            v-if="isMessageOwner && !message.deleted"
          >
            <v-icon color="bhGray--2">bhi-reply</v-icon>
          </v-btn>
          <chat-message-menu
            @editMessage="
              $emit('setSelectedMessage', {
                ...message,
                text: message.text,
                method: 'EDIT',
              })
            "
            @removeMessage="$emit('removeMessage')"
            @copyMessage="$emit('copyMessage')"
            @askAi="$emit('askAi')"
            :is-message-owner="isMessageOwner"
            :direct-chat="directChat"
            v-if="isMessageOwner && !message.deleted"
          />
        </div>
        <v-menu
          top
          right
          max-width="100%"
          open-on-hover
          offset-y
          rounded="pill"
          :disabled="
            message.deleted ||
              isSprintMessageOutside ||
              isThisChannelSprintChannel
          "
        >
          <template v-slot:activator="{ on }">
            <div
              class="chat-message"
              :class="{
                'chat-message--transparent-background':
                  mediaObj && mediaObj.isPubnubFile,
              }"
              v-on="mediaObj && mediaObj.isPubnubFile ? null : on"
            >
              <div class="chat-message-reply" v-if="replyMessage">
                <p
                  class="chat-message-reply-text"
                  v-if="!replyMessage.message.deleted"
                  v-html="parsed(replyMessage.message.text)"
                >
                  {{ replyMessage.message.text }}
                </p>
                <p
                  class="chat-message-reply-text font-italic text--disabled"
                  v-if="replyMessage.message.deleted"
                >
                  Message removed
                </p>
              </div>
              <div
                class="chat-message-main"
                :class="{
                  'chat-message-main--activeUser': isMessageOwner,
                  'chat-message-main--has-reaction': messageHasReaction,
                }"
              >
                <div v-if="!message.deleted && mediaObj.type">
                  <v-img
                    class="chat-message-main-image"
                    :class="{
                      'chat-message-main-image--pubnubfile':
                        mediaObj.isPubnubFile,
                    }"
                    v-if="mediaObj.type === 'image' && !mediaObj.processing"
                    :src="
                      mediaObj.thumbnailUrl ||
                        mediaObj.previewUrl ||
                        mediaObj.url
                    "
                    :max-height="mediaObj.isPubnubFile ? '130' : '200'"
                    :max-width="mediaObj.isPubnubFile ? '130' : '200'"
                    contain
                    @click="showBiggerImage"
                    @load="imageLoaded"
                  />
                  <video
                    :ref="'video-' + messageId"
                    height="180"
                    width="320"
                    v-else-if="mediaObj.type === 'video'"
                    :poster="mediaObj.previewUrl || mediaObj.thumbnailUrl || ''"
                    controls=""
                    name="media"
                    @error="
                      videoError(mediaObj.mlResourceUrl, 'video-' + messageId)
                    "
                  >
                    <source :src="mediaObj.url" :type="`video/mp4`" />
                  </video>
                  <v-progress-circular
                    v-else-if="mediaObj.processing"
                    indeterminate
                    color="bhWhite"
                    size="32"
                    :width="2"
                  ></v-progress-circular>
                  <div v-else class="chat-message-unknown-file">
                    <v-img
                      v-if="mediaObj.type === 'pdf'"
                      :src="mediaObj.thumbnailUrl || mediaObj.previewUrl"
                      max-width="50"
                      max-height="50"
                      contain
                      @click="showBiggerImage"
                    />
                    <v-icon v-else class="chat-message-unknown-file--icon"
                      >bhi-file</v-icon
                    >
                    <div class="ml-2">
                      <span class="chat-message-unknown-file--name">{{
                        mediaObj.name
                      }}</span>
                      <span
                        class="chat-message-unknown-file--link"
                        @click="
                          $emit('downloadResourceByUrl', mediaObj.mlResourceUrl)
                        "
                        >Download File</span
                      >
                    </div>
                  </div>
                </div>
                <v-img
                  class="chat-message-main-image"
                  v-if="
                    !message.deleted &&
                      message.giphyFile &&
                      message.giphyFile.images.original.url
                  "
                  :src="message.giphyFile.images.original.url"
                  max-height="200"
                  max-width="200"
                  contain
                />
                <div
                  v-if="!message.deleted && message.text"
                  class="d-flex align-center"
                >
                  <v-btn
                    v-if="message.lng"
                    icon
                    small
                    class="mr-2"
                    :loading="
                      audioPlayerIsLoading &&
                        audioPlayerFileKey === originalMessageFileKey
                    "
                    @click="
                      () => {
                        audioPlayerIsPlaying &&
                        audioPlayerFileKey === originalMessageFileKey
                          ? stopPlayMessage()
                          : playMessage(message.text, message.lng, date)
                      }
                    "
                  >
                    <v-icon>{{
                      audioPlayerIsPlaying &&
                      audioPlayerFileKey === originalMessageFileKey
                        ? 'bhi-volume-off'
                        : 'bhi-volume-up'
                    }}</v-icon>
                  </v-btn>
                  <p
                    class="chat-message-main-text mb-0 "
                    :class="{ 'mt-2': mediaObj.url }"
                    v-html="parsed(message.text)"
                  >
                    {{ parsed(message.text) }}
                  </p>
                </div>
                <v-btn
                  :color="isMessageOwner ? 'black' : 'accent'"
                  :loading="translatedMessageIsLoading"
                  text
                  small
                  v-if="
                    !message.deleted &&
                      message.text &&
                      user.language !== message.lng &&
                      translatedMessage === null &&
                      message.lng
                  "
                  @click="tryTranslateMessage"
                >
                  Translate message
                </v-btn>
                <p
                  class="translated_message_label"
                  v-if="
                    !message.deleted &&
                      message.text &&
                      user.language !== message.lng &&
                      translatedMessage !== null &&
                      message.lng
                  "
                >
                  Translated message
                </p>
                <div
                  v-if="
                    !message.deleted &&
                      message.text &&
                      user.language !== message.lng &&
                      !translatedMessageIsLoading &&
                      translatedMessage !== null
                  "
                  class="d-flex align-center"
                >
                  <v-btn
                    v-if="message.lng"
                    icon
                    small
                    class="mr-2"
                    :loading="
                      audioPlayerIsLoading &&
                        audioPlayerFileKey === translatedMessageFileKey
                    "
                    @click="
                      () => {
                        audioPlayerIsPlaying &&
                        audioPlayerFileKey === translatedMessageFileKey
                          ? stopPlayMessage()
                          : playMessage(translatedMessage, user.language, date)
                      }
                    "
                  >
                    <v-icon>{{
                      audioPlayerIsPlaying &&
                      audioPlayerFileKey === translatedMessageFileKey
                        ? 'bhi-volume-off'
                        : 'bhi-volume-up'
                    }}</v-icon>
                  </v-btn>
                  <p
                    class="chat-message-main-text mb-0 "
                    :class="{ 'mt-2': mediaObj.url }"
                    v-html="`<i>${parsed(translatedMessage || '')}</i>`"
                  ></p>
                </div>
                <p
                  v-if="message.deleted"
                  class="chat-message-main-text mb-0 font-italic text--disabled"
                  :class="{ 'mt-2': mediaObj.url }"
                >
                  Message removed
                </p>
                <div
                  v-if="
                    !isThisChannelSprintChannel &&
                      !isSprintMessageOutside &&
                      message.reactions &&
                      message.reactions.length
                  "
                  class="chat-message-main-emoji"
                  :style="{
                    bottom: -0.5 * (iconSize + 2 * emojiGutter) + 'px',
                  }"
                >
                  <emoji-reactions
                    :size="0.75 * iconSize"
                    :gutter="emojiGutter"
                    :reactions="message.reactions"
                    :chat-users="chatUsers"
                    @reactionClicked="$emit('reactionClicked', $event)"
                  />
                </div>
              </div>
              <chat-message-confirmation
                v-if="message.needAck"
                :message="message"
                :is-message-owner="isMessageOwner"
                @ackMessage="$emit('ackMessage')"
              />
            </div>
          </template>
          <v-card class="chat-message-reaction-wrapper">
            <span
              class="chat-message-reaction-item"
              v-for="(reaction, index) in reactions"
              :key="index"
              @click="$emit('reactionClicked', reaction)"
            >
              <v-img
                v-if="reaction.type.split('.')[1]"
                :src="require(`../../../assets/reactions/${reaction.type}`)"
                :alt="reactions.find(item => item.type === reaction.type).title"
                contain
                :height="iconSize"
                :width="iconSize"
              />
              <span v-else>{{ reaction.type }}</span>
            </span>
          </v-card>
        </v-menu>
        <profile-preview-image
          v-if="isMessageOwner"
          :uuid="userUuid || message.user"
          :avatarClasses="['avatar', 'rounded', `ml-4`]"
          :avatarSize="avatarSize"
        />
        <div class="chat-message--hover-display chat-message-actions-buttons">
          <chat-message-menu
            @editMessage="
              $emit('setSelectedMessage', {
                ...message,
                text: message.text,
                method: 'EDIT',
              })
            "
            @removeMessage="$emit('removeMessage')"
            @copyMessage="$emit('copyMessage')"
            @askAi="$emit('askAi', senderUser.profileId)"
            :is-message-owner="isMessageOwner"
            :is-role-allowed="isRoleAllowed"
            :direct-chat="directChat"
            v-if="
              !isSprintMessageOutside && !isMessageOwner && !message.deleted
            "
          />
          <v-btn
            class="chat-message__reply-button"
            @click="
              $emit('setSelectedMessage', {
                ...message,
                text: '',
                method: 'REPLY',
              })
            "
            type="reverse"
            icon
            small
            v-if="
              !isMessageOwner && !message.deleted && !isSprintMessageOutside
            "
          >
            <v-icon color="bhGray--2">bhi-reply</v-icon>
          </v-btn>
        </div>
      </v-row>
      <v-row :justify="isMessageOwner ? 'end' : 'start'">
        <p
          :class="{ [`mt-${messageHasReaction ? 2 : 1}`]: true }"
          class="chat-message-footer mb-0 px-6"
        >
          <v-icon
            v-if="isMessageOwner"
            class="mr-2"
            :color="messageIsRead ? 'accent' : 'bhGray2'"
          >
            {{ messageIsRead ? 'bhi-double-check' : 'bhi-check' }}
          </v-icon>
          <span
            :class="
              `chat-message-footer-text ${isMessageOwner &&
                'chat-message-footer-text--reverse'}`
            "
          >
            <span
              class="chat-message-footer-text--name"
              v-if="isSprintMessageOutside"
              >Copy of sprint message: {{ formattedDate }}</span
            >
            <span class="chat-message-footer-text--name" v-else
              >{{ userName }} {{ formattedDate }}</span
            >
            <i
              class="chat-message-footer-text--edited"
              v-if="message.updated && !message.deleted"
              >Edited</i
            >
          </span>
        </p>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {
  getFileTypeByUrl,
  getFileTypeByName,
  filePlaceholder,
  prepareTimetokenDate,
} from '@/helpers/chat'
import EmojiReactions from './EmojiReactions'
import ChatMessageConfirmation from './ChatMessageConfirmation'
import ChatMessageMenu from './ChatMessageMenu'
import ProfilePreviewImage from '@/components/profile/ProfilePreviewImage.vue'
import { getDisplayName } from '@/helpers/getDisplayName'
import LanguagesMixin from '@/mixins/languages'
import AudioPlayerMixin from '@/mixins/audioPlayer'
import { DEFAULT_LANGUAGE } from '../../../helpers/constants'
import StaticMediaMixin from '@/mixins/staticMedia'

export default {
  name: 'ChatMessage',
  components: {
    EmojiReactions,
    ChatMessageConfirmation,
    ChatMessageMenu,
    ProfilePreviewImage,
  },
  mixins: [LanguagesMixin, AudioPlayerMixin, StaticMediaMixin],
  props: {
    channelId: {
      type: String,
      default: '',
    },
    currentUser: {
      type: String,
      default: '',
    },
    message: {
      type: Object,
      default: () => ({}),
    },
    reactions: {
      type: Array,
      default: () => [],
    },
    iconSize: {
      type: Number,
      default: 16,
    },
    date: {
      type: String,
      default: '',
    },
    mediaLibraryFiles: {
      type: [Object, null],
      default: () => null,
    },
    staticMediaId: {
      type: [Number, null],
      default: () => null,
    },
    parseOutputMessageText: {
      type: Function,
      default: e => e,
    },
    getResourceById: {
      type: Function,
      default: () => null,
    },
    chatUsers: {
      type: Array,
      default: () => [],
    },
    file: {
      type: [Object, null],
      default: () => null,
    },
    getFileUrl: {
      type: Function,
      default: () => Promise.resolve(''),
    },
    getMessageByTimetoken: {
      type: Function,
      default: () => null,
    },
    getResourceByUrl: {
      type: Function,
      default: () => null,
    },
    sendExistingResource: {
      type: Function,
      default: () => null,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    isRoleAllowed: {
      type: Boolean,
      default: false,
    },
    directChat: {
      type: Boolean,
      default: true,
    },
    // check if sprint message is in other chat that sprint channel
    isSprintMessageOutside: {
      type: Boolean,
      default: false,
      require: false,
    },
  },
  data() {
    return {
      emojiGutter: 2,
      avatarSize: 24,
      mediaObj: {
        url: '',
        type: null,
        extension: '',
        name: '',
        processing: false,
        previewUrl: false,
        isPubnubFile: false,
      },
      filePlaceholder,
      replyMessage: null,
      sprintMessage: null,
    }
  },
  mounted() {
    if (this.file) {
      this.getFile()
    }
    if (this.message.replyMessageTimetoken) {
      this.getReplyMessage()
    }
    if (
      this.message.sprintMessageChannelId &&
      this.message.sprintMessageTimetoken
    ) {
      this.getSprintMessage()
    }
    if (this.mediaLibraryFiles) {
      let resourceUrl = ''

      if (
        this.isSprintMessageOutside ||
        this.message.user === this.currentUser
      ) {
        resourceUrl = this.mediaLibraryFiles.senderUrl
      } else {
        if (this.mediaLibraryFiles.receiversUrl[this.currentUser]) {
          resourceUrl = this.mediaLibraryFiles.receiversUrl[this.currentUser]
        }
      }

      this.mediaObj = {
        mlResourceUrl: resourceUrl,
        type: 'image',
        name: 'undefined',
        processing: true,
      }

      if (resourceUrl) {
        this.getResourceInfo(this.mediaLibraryFiles.senderUrl)
      }
    }
    this.setStaticMediaFile()
  },
  watch: {
    staticMediaId(val) {
      this.setStaticMediaFile(val)
    },
    staticMedia(val) {
      this.setStaticMediaFile(undefined, val)
    },
    messageId(val) {
      if (this.file) {
        this.getFile()
      }
    },
    replyMessageTimetoken(val) {
      if (val) {
        this.getReplyMessage()
      }
    },
    replyMessageUpdatedAt(val) {
      if (val) {
        this.getReplyMessage()
      }
    },
    sprintMessageTimetoken(val) {
      if (val && !this.sprintMessage) {
        this.getSprintMessage()
      }
    },
    sprintMessageChannelId(val) {
      if (val && !this.sprintMessage) {
        this.getSprintMessage()
      }
    },
  },
  computed: {
    ...mapState('profilePreviewsStates', ['profilePreviews']),
    ...mapState('userStates', ['user']),
    isMessageOwner() {
      return this.message.user === this.currentUser
    },
    messageHasReaction() {
      return !this.isThisChannelSprintChannel &&
        !this.isSprintMessageOutside &&
        this.message.reactions
        ? !!this.message.reactions.length
        : false
    },
    formattedDate() {
      const preparedDate = prepareTimetokenDate(this.date)

      return this.$moment(Date.now()).format('MMMM Do, YYYY') ===
        this.$moment(preparedDate).format('MMMM Do, YYYY')
        ? this.$moment(preparedDate).format('h:mm:ss a')
        : this.$moment(preparedDate).format('MM/DD/YYYY, h:mm:ss a')
    },
    isThisChannelSprintChannel() {
      return this.channelId.indexOf('_sprint_') >= 0
    },
    senderUser() {
      const chatMember = this.chatUsers.find(
        el => el.uuid === this.message.user,
      )

      if (chatMember?.isFreeUser) {
        return { ...chatMember, uuid: this.message.user }
      }

      return (
        this.profilePreviews.find(el => el.uuid === this.message.user) || {
          uuid: this.message.user,
        }
      )
    },
    userUuid() {
      return this.isMessageOwner ? this.currentUser : this.senderUser.uuid
    },
    userName() {
      const {
        fullName,
        nick,
        firstName,
        lastName,
        isFreeUser,
      } = this.senderUser

      return isFreeUser
        ? 'Free User'
        : getDisplayName(fullName, firstName, lastName, nick) ||
            this.message.user
    },
    messageId() {
      return this.message.id
    },
    replyMessageTimetoken() {
      return this.message.replyMessageTimetoken
    },
    replyMessageUpdatedAt() {
      return this.message.replyMessageUpdatedAt
    },
    sprintMessageTimetoken() {
      return this.message.sprintMessageTimetoken
    },
    sprintMessageChannelId() {
      return this.message.sprintMessageChannelId
    },
    messageIsRead() {
      const messageTimetoken = this.date
      const chatMembersTimetokens = this.chatUsers
        .filter(el => el.uuid !== this.userUuid)
        .map(el => el.timeToken)
      const onePersonRead = chatMembersTimetokens.find(
        el => el >= messageTimetoken,
      )
      return !!onePersonRead
    },
    translatedMessage() {
      const userLanguage = this.user.language
      const messageText = this.message.text
      const messageLanguage = this.message.lng

      const translateKey = `${messageLanguage}-${messageText}`
      const translations = {
        ...this.translatedStrings,
      }
      return translations?.[translateKey]?.[userLanguage] || null
    },
    translatedMessageIsLoading() {
      const messageText = this.message.text
      const messageLanguage = this.message.lng
      const translateKey = `${messageLanguage}-${messageText}`

      return this.translatedStringLoading.includes(translateKey)
    },
    originalMessageFileKey() {
      return `${this.date}-${this.message.lng}-${this.message.text}`
    },
    translatedMessageFileKey() {
      return `${this.date}-${this.user.language}-${this.translatedMessage}`
    },
  },
  methods: {
    async setStaticMediaFile(staticMediaId, staticMedia) {
      const currentStaticMediaId = staticMediaId || this.staticMediaId
      const currentStaticMedia = staticMedia || this.staticMedia

      if (currentStaticMediaId && currentStaticMedia) {
        const selectedStaticMedia = currentStaticMedia.find(
          el => el.id === currentStaticMediaId,
        )
        if (selectedStaticMedia?.mediaUrl) {
          this.mediaObj = {
            previewUrl: selectedStaticMedia.mediaUrl,
            thumbnailUrl: selectedStaticMedia.mediaUrl,
            url: selectedStaticMedia.mediaUrl,
            type: 'image',
            name: selectedStaticMedia.name,
            title: selectedStaticMedia.name,
            processing: false,
            isStaticMedia: true,
          }
        }
      }
    },
    async videoError(url, id) {
      await this.getResourceInfo(this.mediaObj.mlResourceUrl)
      this.$refs[id].load()
      this.$refs[id].play()
    },
    async imageLoaded() {
      this.$emit('imageLoaded')
    },
    async showBiggerImage() {
      if (this.mediaObj.isPubnubFile) return
      if (this.mediaObj.mlResourceUrl) {
        this.$emit('showBiggerImage', {
          url: null,
          file: null,
          name: null,
          mlResourceUrl: null,
        }) // Show dialog while getting new s3 file url
        await this.getResourceInfo(this.mediaObj.mlResourceUrl)
      }
      const title =
        this.mediaObj.title.replace(/[/\\?%*:|"<>]/g, '-') +
        '.' +
        this.mediaObj.name
          .split('.')
          .pop()
          .trim()
          .toLowerCase()
      this.$emit('showBiggerImage', {
        url:
          this.mediaObj.url ||
          this.mediaObj.preview ||
          this.mediaObj.previewUrl ||
          this.mediaObj.thumbnailUrl,
        name: title,
        file: this.mediaObj?.isStaticMedia ? this.mediaObj.url : this.file,
        mlResourceUrl: this.mediaObj?.isStaticMedia
          ? null
          : this.mediaObj.mlResourceUrl || null,
        type: this.mediaObj.type === 'pdf' ? 5 : undefined,
      })
    },
    downloadResourceByUrlHandler(resourceUrl) {
      this.$emit('downloadResourceByUrl', resourceUrl)
    },
    getFile() {
      const media = getFileTypeByName(this.file.name)
      const { type, extension } = media
      switch (type) {
        case 'image':
          return this.getFileUrl(this.file).then(url => {
            this.mediaObj = {
              url,
              type,
              name: this.file.name,
              processing: this.file.processing,
              isPubnubFile: true,
            }
          })
        case 'video':
          return this.getFileUrl(this.file).then(url => {
            this.mediaObj = {
              url,
              type,
              extension,
              name: this.file.name,
              previewUrl: this.file.previewUrl,
              isPubnubFile: true,
            }
          })
        case 'pdf':
          return this.getFileUrl(this.file).then(url => {
            this.mediaObj = {
              url,
              type,
              name: this.file.name,
              isPubnubFile: true,
            }
          })
        default:
          this.mediaObj = {
            url: this.file.url || 'unknown',
            type,
            extension,
            name: this.file.name,
            isPubnubFile: true,
          }
          return
      }
    },
    async getReplyMessage() {
      if (this.message.replyMessageTimetoken) {
        const replyMessage = await this.getMessageByTimetoken({
          channelId: this.channelId,
          timetoken: this.message.replyMessageTimetoken,
        })
        this.replyMessage = replyMessage
      }
    },
    async getSprintMessage() {
      if (
        (this.message.sprintMessageChannelId,
        this.message.sprintMessageTimetoken)
      ) {
        const sprintMessage = await this.getMessageByTimetoken({
          channelId: this.message.sprintMessageChannelId,
          timetoken: this.message.sprintMessageTimetoken,
        })
        if (sprintMessage) {
          sprintMessage.message.user = this.message.user
        }
        this.sprintMessage = sprintMessage
      }
    },
    async getResourceInfo(url, shouldRetry = true) {
      return await this.getResourceByUrl({ resourceUrl: url }).then(
        response => {
          const { data } = response

          if (data?.fileUrl) {
            const media = getFileTypeByUrl(data.fileUrl)
            const { type, extension } = media

            this.mediaObj = {
              url: data.fileUrl,
              type: type || 'unknown',
              extension,
              name: data.name,
              title: data.title,
              previewUrl: data.previewUrl || data.fileUrl,
              thumbnailUrl:
                data.thumbnailUrl || data.previewUrl || data.fileUrl,
              mlResourceUrl: url,
              processing: data.processing,
              isPubnubFile: false,
            }
          } else if (data?.processing) {
            this.mediaObj.processing = true
            this.mediaObj.type = 'unknown'
            if (shouldRetry)
              setTimeout(() => {
                this.getResourceInfo(url, false)
              }, 5000)
          }
        },
      )
    },
    parsed(text) {
      const parsedText = this.parseOutputMessageText(text)
      return parsedText.text
    },
    async tryTranslateMessage() {
      const userLanguage = this.user.language
      const messageText = this.message.text
      const messageLanguage = this.message.lng

      this.getTranslation({
        sourceLanguage: messageLanguage,
        sourceText: messageText,
        targetLanguage: userLanguage,
      })
    },
    async stopPlayMessage() {
      await this.stopAudio()
    },
    async playMessage(
      text = '',
      language = DEFAULT_LANGUAGE,
      messageTimetoken = 0,
    ) {
      try {
        await this.stopAudio()
        this.setAudioPlayerIsLoading(true)
        const fileKey = `${messageTimetoken}-${language}-${text}`
        this.setAudioPlayerFileKey(fileKey)
        const fileBinary = await this.getTextToSpeech({
          text,
          language,
        })
        this.playAudio(fileBinary, fileKey)
      } catch (error) {
        // this.setAudioPlayerIsLoading(false)
        console.log(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.chat-message {
  $self: &;
  background-color: $bh-blue--4;
  border-radius: 0.5 * $gutter;
  max-width: 70%;
  min-width: 30%;
  position: relative;

  &--hover-display {
    opacity: 0;
    transition: 200ms opacity ease-in-out;
  }

  &--selected {
    background-color: $bh-gray--6;
  }

  &-container {
    padding: 24px ($gutter + 12) 24px;

    &--reply {
      padding-top: 68px;
    }

    &:hover #{$self}--hover-display {
      opacity: 1;
    }

    &--copied-sprint-message .chat-message {
      background-color: $bh-green;
    }
  }

  &-reply {
    position: absolute;
    top: -44px;
    right: 0;
    background-color: $bh-gray--6;
    width: 100%;
    min-width: 260px;
    padding: $gutter $gutter 1.5 * $gutter;
    display: flex;
    flex-direction: column;
    border-radius: 0.5 * $gutter;

    &-text {
      line-height: $gutter;
      font-size: 0.6875 * $gutter;
      color: $bh-gray--1;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 0;
      overflow: hidden;
    }
  }

  &--transparent-background {
    background-color: transparent;

    #{$self}-main {
      background-color: transparent;
    }
  }

  &-main {
    position: relative;
    padding: $gutter 1.5 * $gutter;
    display: flex;
    flex-direction: column;

    &--activeUser {
      background-color: $bh-blue--2;
      text-align: right;
      border-radius: 0.5 * $gutter;
      align-items: flex-end;

      .chat-message-unknown-file {
        color: #fff;
        &--icon {
          color: #fff;
        }
      }

      .chat-message {
        &-text {
          color: $bh-white;
        }
      }
    }

    &--has-reaction {
      padding-bottom: 1.5 * $gutter;
    }

    &-text {
      line-height: 1.5 * $gutter;
      font-size: $gutter;
      color: $bh-black;
      white-space: pre-wrap;
      word-break: break-word;
    }

    &-image {
      cursor: pointer;
      border-radius: 0.5 * $gutter;

      &--pubnubfile {
        cursor: default;
      }
    }

    &-emoji {
      position: absolute;
      left: 0.5 * $gutter;
    }
  }

  &-unknown-file {
    display: flex;
    cursor: pointer;
    color: $bh-blue;

    &:hover span {
      text-decoration: underline;
    }

    &--icon {
      color: $bh-blue;
      font-size: 32px;
    }
    &--name,
    &--link {
      display: inline-block;
      width: 100%;
      text-align: left;
    }
  }

  &-reaction {
    &-wrapper {
      display: flex;
      align-items: center;
      line-height: 1.5 * $gutter;
      height: 48px;
      padding: 0.75 * $gutter $gutter;
    }

    &-item {
      cursor: pointer;
      line-height: 1.5 * $gutter;
      font-size: $gutter;
      margin-left: 0.5 * $gutter;

      &:first-child {
        margin-left: 0;
      }
    }
  }

  &-footer {
    &-text {
      font-size: 0.75 * $gutter;
      line-height: 1.25 * $gutter;
      color: $bh-gray--2;
      font-weight: 300;

      &--name,
      &--edited {
        margin: 0 16px;
      }
    }
  }

  &__reply-button {
    z-index: 2;
  }

  .translated_message_label {
    font-size: 10.5px;
  }
}
</style>
